import { render, staticRenderFns } from "./modelView.vue?vue&type=template&id=704a9e8a"
import script from "./modelView.vue?vue&type=script&lang=js"
export * from "./modelView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports